import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useState } from 'react';
import { ChooseMethod } from './components/ChooseMethod';
import { FinishedResetPassword } from './components/FinishedResetPassword';
import { NewPassword } from './components/NewPassword';
import { TokenValidation } from './components/TokenValidation';
import { useResetPasswordData } from './hooks';
export function ResetPassword({ onBackToLogin, onRedirectToOnboarding }) {
    const [currentStep, setCurrentStep] = useState('choose-method');
    const [accountData, setAccountData] = useState(null);
    const [selectedMethod, setSelectedMethod] = useState('email');
    const [hasResetError, setHasResetError] = useState(false);
    const { cpf, clearData } = useResetPasswordData();
    const handleChooseMethodContinue = (_newCpf, newMethod, newAccountData) => {
        setAccountData(newAccountData);
        setSelectedMethod(newMethod);
        setCurrentStep('token-validation');
    };
    const handleTokenValidationBack = () => {
        setCurrentStep('choose-method');
    };
    const handleTokenValidationContinue = () => {
        setCurrentStep('new-password');
    };
    const handleNewPasswordBack = () => {
        setCurrentStep('token-validation');
    };
    const handleNewPasswordSuccess = useCallback(() => {
        setHasResetError(false);
        setCurrentStep('finished');
        clearData();
    }, [clearData]);
    const handleNewPasswordError = useCallback(() => {
        setHasResetError(true);
        setCurrentStep('finished');
    }, []);
    const email = accountData?.email ?? '';
    const phone = accountData?.phoneNumber ?? '';
    const tokenSource = selectedMethod === 'email' ? 'email' : 'sms';
    return (_jsxs("div", { "data-testid": 'reset-password-wrapper', children: [currentStep === 'choose-method' && (_jsx(ChooseMethod, { onBackToLogin: onBackToLogin, onContinue: handleChooseMethodContinue, onRedirectToOnboarding: onRedirectToOnboarding })), currentStep === 'token-validation' && (_jsx(TokenValidation, { source: tokenSource, email: email, phone: phone, onBack: handleTokenValidationBack, onContinue: handleTokenValidationContinue })), currentStep === 'new-password' && (_jsx(NewPassword, { cpf: cpf, onBack: handleNewPasswordBack, onSuccess: handleNewPasswordSuccess, onError: handleNewPasswordError })), currentStep === 'finished' && _jsx(FinishedResetPassword, { hasError: hasResetError, onBackToLogin: onBackToLogin })] }));
}
